import React from "react";

import HomeCardsSection, { CardsConfigEntry } from "./subcomponents/HomeCardsSection";
import useMediaQuery from "../hooks/useMediaQuery";

const BusinessHomeConfig: CardsConfigEntry[] = [
  {
    title: "For Business",
    text: "By allowing us to become a temporary shareholder in your home, we can give you funds and remain patient for up to 3 years to be paid back anything",
    ctaPath: "/business/for-business",
    ctaText: "Find out more",
    image: "https://fintree-public-media.s3.ap-southeast-2.amazonaws.com/deposit-boost.jpg",
  },
  {
    title: "Buy Now Pay Later",
    text: `If you just need some short term funds for cashflow purposes, we'll let you pay back in 3-4 installments, every 2 weeks or every month.
    The fee is 1% for every 2 weeks until we are paid back. A small shareholding against your home is a backup for up, if you're unable to pay on time.`,
    ctaPath: "/business/bnpl",
    ctaText: "Find out more",
    image: "https://fintree-public-media.s3.ap-southeast-2.amazonaws.com/buying-boost.jpg",
  },
];

const Home = () => {
  const isMobile = useMediaQuery("991px");

  const headerText = `Fund your business now`;
  const subHeaderText = `We become a small shareholder in your home, until your business has grown to pay us back.`;

  const paragraphOne = `BuySooner is much more patient than a small business loan. We give you funds and then can wait for your business to grow, or for your home to appreciate and be refinanced, before you have to repay us anything.`;
  const paragraphTwo = `This removes short term pressure on your cashflows to pay back a loan, so your business has the breathing room to focus on its growth.`;
  const paragraphThree = `Our fee is calculated as based on the value and growth of your home, but we do not go on title, it stays all in your name.`;

  return (
    <div className="flex flex-col flex-1">
      <section className={`relative text-center py-20 text-[#010305] bg-inherit ${isMobile ? "mobile" : "desktop"}`}>
        <div className="max-w-[1200px] mx-auto px-4">
          <h4 className="text-[#79C4AF] text-[clamp(3rem,5.5vw,5rem)] max-w-[14ch] leading-[1.35] font-bold max-md:text-left max-md:leading-[4rem] max-md:font-black max-md:text-[3.5rem] max-md:pb-5">
            {headerText}
          </h4>
          <h4 className="max-w-[75%] font-bold text-[1.75rem] mt-2 max-md:text-left max-md:text-2xl max-md:max-w-full max-md:mb-20">
            {subHeaderText}
          </h4>
          <br />
          <div className="text-base max-w-[50%] max-md:text-left max-md:py-5 max-md:max-w-full">
            <p className="mt-3">{paragraphOne}</p>
            <p className="mt-3">{paragraphTwo}</p>
            <p className="mt-3">{paragraphThree}</p>
          </div>
        </div>
      </section>

      {/*<BusinessBoostSteps/>*/}
      <HomeCardsSection cardsConfig={BusinessHomeConfig} />
    </div>
  );
};

Home.propTypes = {};

export default Home;
